import { SELECTORS } from '$utils/constants';
import { displayElement } from '$utils/helpers/displayElement';
import { findProfiles } from '$utils/helpers/findProfiles';
import { formatNumber } from '$utils/helpers/formatNumber';
import { populateProfiles } from '$utils/helpers/populateProfiles';
import { setupFilterComponents } from '$utils/helpers/setupFilterComponents';

window.Webflow ||= [];
window.Webflow.push(async () => {
  const findSuccess = document.querySelector(SELECTORS.findSuccess) as HTMLElement;
  displayElement(findSuccess, false);
  const reqBody = localStorage.getItem('reqBody');
  if (reqBody) {
    const loader = document.querySelector(SELECTORS.loader) as HTMLElement;
    displayElement(findSuccess, true);
    displayElement(loader, true);
    localStorage.removeItem('reqBody');
    const parsedReqBody = JSON.parse(reqBody);

    const fetchedProfiles = await findProfiles(parsedReqBody);

    if (fetchedProfiles) {
      const creatorTotal = document.querySelector(SELECTORS.creatorTotal) as HTMLElement;
      creatorTotal.innerText = formatNumber(fetchedProfiles.metadata.total_results).toString();
      populateProfiles(fetchedProfiles.data);
    }
  }
  setupFilterComponents(false);
});
